import { render, staticRenderFns } from "./card-strategy-status.component.vue?vue&type=template&id=f5b4d4b6&scoped=true"
import script from "./card-strategy-status.component.vue?vue&type=script&lang=js"
export * from "./card-strategy-status.component.vue?vue&type=script&lang=js"
import style0 from "./card-strategy-status.component.vue?vue&type=style&index=0&id=f5b4d4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b4d4b6",
  null
  
)

export default component.exports